import React from 'react';
import { Search } from 'lucide-react';
import './SearchInput.css';

const SearchInput = ({
  value,
  onChange,
  placeholder = 'Search...',
  className = '',
  inputClassName = '',
  ...props
}) => {
  return (
    <div className={`search-input-wrapper ${className}`}>
      <Search className="search-icon" size={16} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`search-input ${inputClassName}`}
        {...props}
      />
    </div>
  );
};

export default SearchInput;
